// src/pages/Terms.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/theme.css';
import '../styles/Dashboard.css';

export default function Terms() {
  return (
    <main className="dashboard-fade-in">
      <Header />
      <div className="container page">
        <header className="dash-head">
          <h1>Terms of Service</h1>
          <p className="meta">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </header>

        <section className="card">
          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using Your Highest Self ("the Service"), you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section className="card">
          <h2>Description of Service</h2>
          <p>
            Your Highest Self provides daily SMS messages containing spiritual wisdom, affirmations, and personalized insights.
            The Service is subscription-based with monthly billing.
          </p>
        </section>

        <section className="card">
          <h2>Account Registration</h2>
          <ul className="list">
            <li>You must provide a valid phone number to create an account</li>
            <li>You are responsible for maintaining the security of your account</li>
            <li>You must be at least 18 years old to use the Service</li>
            <li>One account per phone number</li>
            <li>You agree to provide accurate, current, and complete information</li>
          </ul>
        </section>

        <section className="card">
          <h2>Subscription and Billing</h2>
          <ul className="list">
            <li>Subscriptions are billed monthly in advance</li>
            <li>Payment is processed through Stripe</li>
            <li>Subscriptions automatically renew unless cancelled</li>
            <li>You may cancel at any time through the billing portal</li>
            <li>Refunds are not provided for partial months</li>
            <li>We reserve the right to modify pricing with 30 days notice</li>
          </ul>
        </section>

        <section className="card">
          <h2>Message Delivery</h2>
          <ul className="list">
            <li>Daily messages are delivered via SMS between 8-9 AM in your timezone</li>
            <li>Delivery times may vary based on carrier and network conditions</li>
            <li>Standard SMS rates from your carrier may apply</li>
            <li>We are not responsible for delayed or undelivered messages due to carrier issues</li>
            <li>Message content is for informational and inspirational purposes only</li>
          </ul>
        </section>

        <section className="card">
          <h2>Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="list">
            <li>Use the Service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to the Service</li>
            <li>Interfere with or disrupt the Service</li>
            <li>Use automated systems to access the Service</li>
            <li>Resell or redistribute the Service</li>
          </ul>
        </section>

        <section className="card">
          <h2>Intellectual Property</h2>
          <p>
            All content provided through the Service, including text, graphics, logos, and software,
            is the property of Your Highest Self or its licensors and is protected by copyright and
            other intellectual property laws.
          </p>
        </section>

        <section className="card">
          <h2>Disclaimer of Warranties</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. We do not guarantee that
            the Service will be uninterrupted, error-free, or completely secure.
          </p>
          <p>
            <b>The content provided is for inspirational and informational purposes only and should not
            be considered professional advice.</b> Please consult qualified professionals for medical,
            psychological, financial, or legal matters.
          </p>
        </section>

        <section className="card">
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Your Highest Self shall not be liable for any
            indirect, incidental, special, or consequential damages arising from your use of the Service.
          </p>
        </section>

        <section className="card">
          <h2>Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at any time for violation of
            these Terms. You may terminate your account by cancelling your subscription through the
            billing portal.
          </p>
        </section>

        <section className="card">
          <h2>Changes to Terms</h2>
          <p>
            We may modify these Terms at any time. We will notify users of material changes via email
            or through the Service. Continued use after changes constitutes acceptance of the new Terms.
          </p>
        </section>

        <section className="card">
          <h2>Governing Law</h2>
          <p>
            These Terms are governed by the laws of the United States. Any disputes shall be resolved
            in the appropriate courts.
          </p>
        </section>

        <section className="card">
          <h2>Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us.
          </p>
          <div className="row row--start" style={{ marginTop: '1rem' }}>
            <Link to="/" className="btn btn--ghost">
              Back to Home
            </Link>
          </div>
        </section>
      </div>
      <Footer />
    </main>
  );
}
